import { useMemo } from 'react';
import { useTheme } from 'context/ThemeContext';
import { buildDashboardThemeTokens } from './dashboardThemeTokens';

const useDashboardTheme = () => {
    const { theme: themeKey } = useTheme();
    return useMemo(() => buildDashboardThemeTokens(themeKey), [themeKey]);
};

export default useDashboardTheme;
